import React, { CSSProperties } from 'react';
import { Project, ProjectNewsCounts } from '../../../../models/Project';
import { ProjectId, ProjectTabViews } from '../../../../models/Types';
import ProjectMenu from '../ProjectMenu';
import NavigationItemPanelHeaderProject from './NavigationItemPanelHeaderProject';

interface ProjectDropDownNavigationItemProps {
  className?: string;
  isSubMenu: boolean;
  key: string;
  style: CSSProperties;
  project?: Project;
  pathPrefix?: string;
  selectedSubModule?: string;
  activeProjectId: ProjectId;
  isProjectMember?: boolean;
  type?: ProjectTabViews;
  isParentProject?: boolean;
  collapsed?: boolean;
  subProjects?: {
    [projectId: string]: string[];
  };
  setCollapsed?: (projectId: ProjectId, collapsed: boolean) => void;
  isAnySubProjectFavorited?: boolean;
  activeTab?: string;
  rerenderProjectList?: () => void;
  getProjectNewsCountsByProjectId?: (projectId: ProjectId) => ProjectNewsCounts;
  getProjectById: (projectId: ProjectId) => Project | undefined;
}

export const ProjectDropDownNavigationItem: React.FC<
  ProjectDropDownNavigationItemProps
> = (props) => {
  //#region ------------------------------ Defaults
  const {
    project,
    style,
    pathPrefix,
    selectedSubModule,
    activeProjectId,
    isProjectMember,
    type,
    isSubMenu,
    isParentProject,
    collapsed,
    subProjects,
    className,
    setCollapsed,
    isAnySubProjectFavorited,
    activeTab,
    rerenderProjectList,
    getProjectNewsCountsByProjectId,
    getProjectById,
  } = props;
  //#endregion

  //#region ------------------------------ States / Attributes / Selectors
  const newsCounts = getProjectNewsCountsByProjectId(project?.projectId);
  //#endregion

  //#region ------------------------------ Methods / Handlers
  //#endregion

  //#region ------------------------------ Effects
  //#endregion

  return (
    <div
      className={className}
      style={{
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        transition: 'height 0.2s',
        ...style,
        ...(isSubMenu
          ? {
              height: 40,
            }
          : {}),
      }}
    >
      <NavigationItemPanelHeaderProject
        project={project}
        rootPath={pathPrefix}
        projectReady={
          project?.projectStatus === 'ready' ||
          project?.projectStatus === 'finished'
        }
        isProjectMember={isProjectMember}
        isSubMenu={isSubMenu}
        type={type}
        isActive={activeProjectId === project.projectId}
        isParentProject={isParentProject}
        collapsed={collapsed}
        subProjects={subProjects}
        setCollapsed={setCollapsed}
        isAnySubProjectFavorited={isAnySubProjectFavorited}
        activeTab={activeTab}
        rerenderProjectList={rerenderProjectList}
        projectNewsCounts={newsCounts}
      />
      {!isSubMenu &&
        !project.isTemporary &&
        activeProjectId === project.projectId && (
          <div style={{ flex: 1 }}>
            <ProjectMenu
              projectId={project.projectId}
              selectedProjectId={activeProjectId}
              selectedSubModule={selectedSubModule}
              masterPlanId={project.masterPlanId}
              groupId={project.groupId}
              emailSuffix={project.eMailSuffix}
              emailPrefix={project.eMailPrefix}
              pathPrefix={pathPrefix}
              projectNewsCounts={newsCounts}
              activeTab={activeTab}
              getProjectById={getProjectById}
            />
          </div>
        )}
    </div>
  );
};

export default ProjectDropDownNavigationItem;
